import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20vibrant%20and%20artistic%20illustration%20of%20a%20comic%20book%20universe%20with%20floating%20manga%20panels%20and%20dynamic%20action%20lines%2C%20colorful%20coral%20orange%20and%20warm%20amber%20accent%20splashes%2C%20whimsical%20speech%20bubbles%20drifting%20across%20a%20dreamy%20cream%20and%20soft%20peach%20gradient%20background%2C%20stylized%20silhouettes%20of%20comic%20characters%20in%20various%20action%20poses%2C%20abstract%20geometric%20shapes%20and%20speed%20lines%2C%20modern%20minimalist%20Japanese-inspired%20flat%20illustration%20style%2C%20warm%20atmospheric%20lighting%2C%20clean%20composition&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="喵趣漫画 - 韩漫日漫国漫免费全集在线阅读平台"
        title="喵趣漫画网"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/40"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="text-2xl md:text-5xl font-heading text-background-50 mb-4 leading-tight">
          喵趣漫画网
        </h1>
        <p className="text-sm md:text-lg text-background-50/90 max-w-2xl mb-6 leading-relaxed">
          韩漫、日漫、国漫免费全集，下拉式在线阅读，一口气看完热门漫画大全
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/all"
            className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            立即阅读
          </Link>
          <Link
            to="/category/korean"
            className="px-6 py-2.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
          >
            韩漫专区
          </Link>
          <Link
            to="/category/japanese"
            className="px-6 py-2.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
          >
            日漫专区
          </Link>
          <Link
            to="/category/chinese"
            className="px-6 py-2.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
          >
            国漫专区
          </Link>
        </div>
        <div className="mt-8 flex items-center gap-3 text-xs text-background-50/70">
          <span className="flex items-center gap-1">
            <i className="ri-book-open-line"></i>
            1000+ 漫画资源
          </span>
          <span className="w-1 h-1 rounded-full bg-background-50/40"></span>
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            500万+ 活跃读者
          </span>
          <span className="w-1 h-1 rounded-full bg-background-50/40"></span>
          <span className="flex items-center gap-1">
            <i className="ri-download-2-line"></i>
            每日更新
          </span>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}